import React, { useState, useEffect, useRef, useCallback } from "react";

import {
  getGoods,
  getGoodStatus,
  IGood,
  getCustomSearchCategory,
  CategoryItem,
} from "../../api";
import { GOODSSTATUS, BUSINESS_INFO } from "../../constant";

import Good from "../Good";
import GoodsSort from "../GoodsSort";
import Pager from "../Pager";
import Placeholder from "../Placeholder";
import PriceRange from "../PriceRange";
import TimeRange from "../TimeRange";
import FinancialPolicy from "../FinancialPolicy";
import Radio from "../Radio";
import Location from "../Location";
import KeyWord from "../KeyWord";

import styles from "./GoodsList.module.css";

const PAGESIZE = 40;
// let syncInterval: any = null
interface GListProps {
  venderId: Number;
  publishSource: string;
}

let timerInterval: any = null;

const GoodsList: React.FC<GListProps> = (props) => {
  const { venderId, publishSource } = props;

  const containerRef = useRef<HTMLDivElement>(null);
  const goodsRef = useRef<IGood[]>([]);

  const [goods, setGoods] = useState<IGood[]>([]);

  const [childrenCateId, setChildrenCateId] = useState(-1);
  const [paimaiStatus, setPaimaiStatus] = useState(-1);
  const [page, setPage] = useState(1);
  const [provinceId, setProvinceId] = useState(-1);
  const [cityId, setCityId] = useState(-1);
  const [countyId, setCountyId] = useState(-1);
  const [sortField, setSortField] = useState("8");
  const [total, setTotal] = useState(0);
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [purchaseRestriction, setPurchaseRestriction] = useState("");
  const [loan, setLoan] = useState("");
  const [keyword, setKeyWord] = useState("");
  const [timeRangeStart, setTimeRangeStart] = useState("");
  const [timeRangeEnd, setTimeRangeEnd] = useState("");
  const [searchParam, setSearchParam] = useState("");
  const [goodsCategory, setGoodsCategory] = useState<CategoryItem[]>([]);

  const [empty, setEmtpy] = useState(false);

  useEffect(() => {
    return commonentWillUnmount;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function commonentWillUnmount() {
    clearInterval(timerInterval);
    timerInterval = null;
  }

  const getGoodsCategory = () => {
    getCustomSearchCategory({ publishSource }).then((res) => {
      if (res && res.length > 0 && JSON.stringify(res) !== "{}") {
        let goodsCategory = [{ id: -1, name: "不限" }];
        for (let i = 0; i < res.length; i++) {
          const { id, name } = res[i];
          goodsCategory.push({
            id,
            name,
          });
        }
        setGoodsCategory(goodsCategory);
      }
    });
  };

  const fetchData = useCallback(
    (current?: number) => {
      const params: any = {
        page: current || 1,
        pageSize: PAGESIZE,
        keyword, // 搜索key
        vendorId: venderId, // 商家Id
        childrenCateId: childrenCateId, // 拍品三级类目Id
        // multiExcludeThirdCateIdList:'',   // 排除的三级类目； id1,id2,...
        provinceId, // 省id
        cityId, // 市id
        countyId, // 区id
        // excludeProvinceId: '',            // 排除的省id
        multiPaimaiStatus: !(
          paimaiStatus === 5 ||
          paimaiStatus === 6 ||
          paimaiStatus === 7
        )
          ? paimaiStatus
          : "", // 拍卖状态
        sortField, // 排序字段
        currentPriceRangeEnd: end, //
        currentPriceRangeStart: start,
        purchaseRestriction,
        loan,
        timeRangeStart,
        timeRangeEnd,
        timeRangeTime: "auditTime",
        displayStatus:
          paimaiStatus === 5 || paimaiStatus === 6 || paimaiStatus === 7
            ? paimaiStatus
            : "",
        // apiType: getApiTypeByGetItem(parseInt(publishSource)),
        apiType: 12,
      };
      Object.keys(params).forEach((key) => {
        if (params[key] === -1 || params[key] === "") {
          delete params[key];
        }
      });

      getGoods(params).then((res) => {
        let { datas, totalItem } = res;
        setTotal(totalItem || 0);
        setEmtpy(!totalItem);
        if (!datas || !datas.length) {
          return;
        }
        goodsRef.current = datas;
        updateGoods(datas);

        timerInterval && clearInterval(timerInterval);
        timerInterval = setInterval(() => {
          // 过滤预告中&进行中的品
          let activeGoods = goodsRef.current.filter((item: IGood) =>
            [0, 1].includes(item.auctionStatus)
          );
          if (!activeGoods.length) {
            timerInterval && clearInterval(timerInterval);
            return;
          }
          activeGoods.forEach((item) => (item.remainTime -= 1000));

          // 过滤到状态切换点的品，去更新这些品的信息
          let upGoods = activeGoods.filter((item) => item.remainTime <= 0);
          updateGoods(upGoods);
        }, 1000);

        // mock 模拟 倒计时结束触发更新
        // setTimeout(() => {
        //   updateGoods([datas[0]])
        // }, 1000*3);

        // if(syncInterval){
        //   window.clearInterval(syncInterval)
        // }
        // syncInterval = setInterval(() => {
        //   if(datas.length === 0){
        //     window.clearInterval(syncInterval)
        //   }
        //   updateGoods(datas)
        // }, 30 * 1000)
      });
    },
    [
      childrenCateId,
      cityId,
      countyId,
      end,
      keyword,
      loan,
      paimaiStatus,
      provinceId,
      purchaseRestriction,
      sortField,
      start,
      timeRangeEnd,
      timeRangeStart,
      venderId,
    ]
  );

  const updateGoods = (goods: IGood[]) => {
    let ids = goods.map((item: IGood) => item.id);
    if (!ids.length) {
      setGoods([...goodsRef.current]);
      return;
    }
    getGoodStatus(ids).then((res) => {
      // mock 模拟 倒计时结束响应更新
      // if(goods.length == 1){
      //   res[goods[0].id].bidCount = 100
      // }
      goodsRef.current.forEach((item) => {
        if (res[item.id]) {
          item = Object.assign(item, res[item.id]);
        }
      });
      setGoods([...goodsRef.current]);
    });
  };

  useEffect(() => {
    getGoodsCategory();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setPage(1);
    fetchData();
  }, [
    childrenCateId,
    cityId,
    countyId,
    end,
    searchParam,
    paimaiStatus,
    provinceId,
    sortField,
    start,
    purchaseRestriction,
    loan,
    timeRangeStart,
    timeRangeEnd,
    keyword,
    fetchData,
  ]);
  const reset = () => {
    window.location.reload();
  };

  useEffect(() => {
    const target = containerRef.current as HTMLDivElement;
    const currentTop = target.getBoundingClientRect().top;
    const top = target.offsetTop - 51;
    if (currentTop < 0) {
      window.scrollTo(0, top);
    }
  }, [page]);

  return (
    <div className={styles.container} ref={containerRef}>
      <div className={styles.filter}>
        {parseInt(publishSource) === BUSINESS_INFO.POCHAN.code && (
          <KeyWord
            keyword={keyword}
            updateKeyWord={(keyword) => setKeyWord(keyword)}
          />
        )}
        <Radio
          active={childrenCateId}
          handler={(active) => setChildrenCateId(active.id)}
          label="分类"
          list={goodsCategory}
        />
        <Location
          updateProvince={(id: number) => setProvinceId(id)}
          updateCity={(id: number) => setCityId(id)}
          updateCounty={(id: number) => setCountyId(id)}
        />
        <Radio
          active={paimaiStatus}
          handler={(active) => setPaimaiStatus(active.id)}
          label="竞价状态"
          list={GOODSSTATUS}
        />
        {parseInt(publishSource) === BUSINESS_INFO.POCHAN.code && (
          <FinancialPolicy
            purchaseRestriction={purchaseRestriction}
            loan={loan}
            updatePurchaseRestriction={(purchaseRestriction) =>
              setPurchaseRestriction(purchaseRestriction)
            }
            updateLoan={(loan) => setLoan(loan)}
          />
        )}
        {parseInt(publishSource) === BUSINESS_INFO.POCHAN.code && (
          <TimeRange
            timeRangeEnd={timeRangeEnd}
            timeRangeStart={timeRangeStart}
            updateTimeRangeEnd={(timeRangeEnd) => setTimeRangeEnd(timeRangeEnd)}
            updateTimeRangeStart={(timeRangeStart) =>
              setTimeRangeStart(timeRangeStart)
            }
          />
        )}
        <PriceRange
          end={end}
          start={start}
          updateEnd={(end) => setEnd(end)}
          updateStart={(start) => setStart(start)}
        />
      </div>
      <GoodsSort
        active={sortField}
        handler={(active) => setSortField(active)}
        reset={reset}
        search={(searchParam) => setSearchParam(searchParam)}
      />
      {empty ? (
        <Placeholder text="暂无相关拍品，敬请期待更多上拍～" />
      ) : (
        <div className={styles.goods}>
          {goods.map((good, index) => (
            <Good key={index} goodInfo={good} />
          ))}
        </div>
      )}
      <div className={styles.pager}>
        <Pager
          current={page}
          pageSize={PAGESIZE}
          handler={(current) => {
            setPage(current);
            fetchData(current);
          }}
          total={total}
        />
      </div>
    </div>
  );
};

export default GoodsList;
